import React from 'react';
import { withTranslation } from 'react-i18next';
import i18next from 'i18next';
import Header from './components/Header/Header';
import Banner from './components/Banner/Banner';
import './App.less';
import ProjectInfo from './components/ProjectInfo/ProjectInfo';
import Survey from './components/Survey/Survey';
import Footer from './components/Footer/Footer';

class App extends React.Component {

	projectInfo = undefined;
	surveyInfo = undefined;

	primaryColor = process.env.REACT_APP_COLOR_PRIMARY;
	secondaryColor = process.env.REACT_APP_COLOR_SECONDARY;


	constructor() {
		super();
		this.state = {
			surveyToken: '',
			projectInfo: {
				client: '',
				name: '',
				customerProjectManager: '',
				projectManager: '',
				members: [],
				logo: '',
			},
			surveyInfo: null,
			surveyFound: null,
		};
	}

	componentDidMount(prev) {
		let search = window.location.search;
		let params = new URLSearchParams(search);
		const surveyToken = params.get('token');
		i18next.on('languageChanged', this.languageChanged);
		fetch(`/api/getSurvey?token=${surveyToken}`)
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data && data.survey && data.project) {
					this.projectInfo = data.project.value[0].fields;
					this.surveyInfo = data.survey.value[0].fields;
					const projectInfo = this.projectInfo
					const surveyInfo = this.surveyInfo;
					this.setState({
						surveyToken: surveyToken,
						projectInfo: {
							client: this.isLatin() ? projectInfo.ClientEn : (projectInfo.ClientAr || projectInfo.ClientEn),
							name: this.isLatin() ? projectInfo.ProjectNameEn : (projectInfo.ProjectNameAr || projectInfo.ProjectNameEn),
							customerProjectManager: projectInfo.ClientContactName,
							projectManager: projectInfo.ProjectManager.map(member => member.LookupValue),
							projectManagerEmail: projectInfo.ProjectManager.map(member => member.Email),
							accountManagerEmail: projectInfo.AccountManager.map(member => member.Email),
							members: projectInfo.Team.map(member => member.LookupValue),
							logo: projectInfo.ClientLogo.Url || '',
							projectInfo,
						},
						surveyInfo,
						surveyFound: true,
					});
				} else {
					this.setState({ surveyFound: false });
				}
			});
	}

	isLatin = () => {
		const { i18n: { language } } = this.props;
		return language === 'en' || language === 'fr';
	}

	languageChanged = () => {
		const projectInfo = this.projectInfo;
		this.setState({
			projectInfo: {
				...this.state.projectInfo,
				client: this.isLatin() ? projectInfo.ClientEn : (projectInfo.ClientAr || projectInfo.ClientEn),
				name: this.isLatin() ? projectInfo.ProjectNameEn : (projectInfo.ProjectNameAr || projectInfo.ProjectNameEn),
			},
		});
	};

	render() {
		const { surveyFound, projectInfo, surveyInfo, surveyToken } = this.state;
		const { t } = this.props;
		return (
			<div className="App"
			style={{
				'--primary-color': this.primaryColor,
				'--secondary-color': this.secondaryColor,
			  }}
			  >
				<Header value={projectInfo} />
				<Banner />
				{surveyFound === true &&
					(
						<React.Fragment>
							<ProjectInfo projectInfo={projectInfo} surveyInfo={surveyInfo} />
							<Survey surveyInfo={surveyInfo} projectInfo={projectInfo} surveyToken={surveyToken} />
						</React.Fragment>
					)}
					{surveyFound === false &&
					(
						<div className="App__survey-msg">{t('survey_notFound')}</div>
					)}
					{surveyFound === null &&
					(
						<div className="App__survey-msg">{t('survey_loading')}</div>
					)}
				<Footer />
			</div>
		);
	}
}

export default withTranslation('translations')(App);
